import { Link } from "@tanstack/react-router";
import {
  cookieConsentActive,
  showCookiePreferences,
} from "../features/cookie-consent/consent.js";

/**
 * Global footer: legal links + a copyright line. The "Cookie preferences"
 * control is only rendered for visitors who actually have the consent
 * system active (EU/EEA/UK — see `isLikelyEU`); everyone else never sees a
 * banner and so has nothing to re-open.
 */
export function Footer() {
  const showCookieLink = cookieConsentActive();
  const year = new Date().getFullYear();
  return (
    <footer className="border-t mx-divider px-6 py-5 mt-auto">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
        <span>© {year} MakerX Pty Ltd</span>
        <nav
          aria-label="Legal"
          className="flex items-center gap-4 flex-wrap justify-center"
        >
          <Link
            to="/privacy"
            className="hover:text-white/70 transition-colors"
          >
            Privacy
          </Link>
          <Link to="/terms" className="hover:text-white/70 transition-colors">
            Terms
          </Link>
          {showCookieLink && (
            <button
              type="button"
              onClick={showCookiePreferences}
              className="hover:text-white/70 transition-colors"
              data-testid="cookie-preferences-link"
            >
              Cookie preferences
            </button>
          )}
        </nav>
      </div>
    </footer>
  );
}
